import { Box, FormLabel, TextField, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { commonErrorMessage } from 'utils/error-message';

interface AppTextFieldProps {
  id: string;
  title: string;
  required?: boolean;
  defaultValue?: string;
  placeholder?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  inputType?: string;
  errorMessage?: string;
}

const AppTextField: FC<AppTextFieldProps> = ({
  id,
  title,
  required = false,
  defaultValue = '',
  placeholder = '',
  value,
  onChange,
  error = false,
  inputType,
  errorMessage
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: '100%',
      }}
    >
      <FormLabel
        htmlFor={id}
        required={required}
        sx={{
          color: theme.palette.common.black,
          fontSize: '25px !important',
          '& .MuiFormLabel-asterisk': {
            color: theme.palette.common.red,
          },
        }}
      >
        {title}
      </FormLabel>

      <TextField
        sx={{ '& *': { fontSize: '25px !important' } }}
        fullWidth
        id={id}
        defaultValue={defaultValue}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        type={inputType}
        inputProps={{
          sx: {
            height: 25,
          },
        }}
      />
      {error && (
        <Typography
          sx={{
            color: theme.palette.error.main,
            fontSize: theme.typography.fontSize,
            my: '5px',
          }}
        >
          {errorMessage
            ? errorMessage
            : commonErrorMessage.MSE00003(title)
          }
        </Typography>
      )}
    </Box>
  );
};

export default AppTextField;
